import { render, staticRenderFns } from "./TitleDetail.vue?vue&type=template&id=56886688&scoped=true"
import script from "./TitleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetail.vue?vue&type=style&index=0&id=56886688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56886688",
  null
  
)

export default component.exports